module.exports = __webpack_public_path__ + "img/Desk Stationeryd26.2bc98cb1.jpg";